// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__LuEUL","footer":"ModalFilter_footer__3xP7e"};